export default "__VITE_ASSET__Q744H_VN__"